import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

const base = () => `${process.env.REACT_APP_APIUrl}`;

export const abandonedReminderApiService = {
  getSettings() {
    return callAPI(`${base()}${NetworkConfiguration.ADMIN_ABANDONED_REMINDER_SETTINGS}`, "GET", {
      "Content-Type": "application/json",
    });
  },
  updateSettings(payload) {
    return callAPI(`${base()}${NetworkConfiguration.ADMIN_ABANDONED_REMINDER_SETTINGS}`, "PUT", {
      "Content-Type": "application/json",
    }, JSON.stringify(payload));
  },
  sendTestToAllOpenLeads() {
    return callAPI(`${base()}${NetworkConfiguration.ADMIN_ABANDONED_REMINDER_SEND_TEST_ALL_OPEN}`, "POST", {
      "Content-Type": "application/json",
    }, "{}");
  },
  /** multipart field name: `banner`; optional text field: `name` */
  uploadBanner(formData) {
    return callAPI(`${base()}${NetworkConfiguration.ADMIN_ABANDONED_REMINDER_BANNER_UPLOAD}`, "POST", {}, formData);
  },
};
